import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { UnitIntelligenceService } from 'src/app/services/unit-intelligence.service';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
    selector: 'app-intelligence-dashboard',
    templateUrl: './intelligence-dashboard.component.html',
    styleUrls: ['./intelligence-dashboard.component.css']
})
export class IntelligenceDashboardComponent implements OnInit {

    filterFrom = '';
    filterTo = '';
    filterStatusId = '';
    statuses: any[] = [];

    data: any = null;
    loading = false;

    constructor(
        private svc: UnitIntelligenceService,
        private spinner: NgxSpinnerService,
        private utils: UtilsService
    ) { }

    ngOnInit(): void {
        const today = new Date();
        const firstOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
        this.filterFrom = this.toDateInput(firstOfMonth);
        this.filterTo = this.toDateInput(today);

        this.svc.getStatuses().subscribe({
            next: (resp: any) => this.statuses = Array.isArray(resp) ? resp : (resp?.data || [])
        });

        this.fetch();
    }

    private toDateInput(d: Date): string {
        return d.toISOString().slice(0, 10);
    }

    fetch(): void {
        this.loading = true;
        this.spinner.show();
        const params: any = { from: this.filterFrom, to: this.filterTo };
        if (this.filterStatusId) params.status_id = this.filterStatusId;

        this.svc.getDashboard(params).subscribe({
            next: (resp: any) => {
                this.data = resp;
                this.loading = false;
                this.spinner.hide();
            },
            error: () => {
                this.loading = false;
                this.spinner.hide();
                this.utils.alertSwal({ title: 'Error', text: 'No se pudo obtener el Centro de inteligencia operativa', icon: 'error' });
            }
        });
    }

    onFilterChanged(): void {
        this.fetch();
    }

    formatCurrency(value: number | null | undefined): string {
        if (value === null || value === undefined) return '—';
        return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value);
    }

    formatKm(value: number | null | undefined): string {
        if (value === null || value === undefined) return '—';
        return `${new Intl.NumberFormat('es-MX').format(value)} km`;
    }
}
